import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../contexts/userContext';
import request from '../../services/Request';
import ModernTable, {
  ModernPageContainer,
  ModernPageHeader,
} from '../dashboard/components/ModernTable';
import { useTheme } from '@mui/material/styles';
import LoadingIcon from '../items/buttons/LoadingIcon';
import Swal from 'sweetalert2';
import AddPlan from './AddPlan';
import { userLimits } from '../dashboard/uitls/userLimits';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CancelIcon from '@mui/icons-material/Cancel';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import ProductPositionModal from './ArrangeProduct/ProductPositionModal';
import { CloudDownload } from '@mui/icons-material';
import { ExportToCsv } from 'export-to-csv';
import AddBundleToMachine from './ArrangeProduct/AddBundleToMachine';
import { Typography, Box, Chip, alpha } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from 'react-router';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import CategoryIcon from '@mui/icons-material/Category';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SaveIcon from '@mui/icons-material/Save';
import AddIcon from '@mui/icons-material/Add';
import EventIcon from '@mui/icons-material/Event';

const addProdToMachineURL = `/machines/updateProduct`;
const getMachineURL = `/machines/getMachineProductOverPlano`;

export default function AddProductToMachine(props) {
  const theme = useTheme();
  const history = useHistory();
  const { filterd, setFiltered } = useContext(UserContext);

  const { id, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    '',
    'edit_machine'
  );
  const user = JSON.parse(localStorage.getItem('user'));
  const advanced = user?.features?.advanced;
  const additionPriceOn = user?.features?.additionPrice;
  const theme1 = user?.theme;
  let lasturl = window.location.href.split('/').pop();
  const machineID = lasturl != 'all' ? lasturl : null;

  const [finalProd, setFinalProd] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reflesh, setReflesh] = useState(false);
  const [title, setTitle] = useState('');
  const [all, setAll] = useState(true);
  const tableRef = React.useRef();

  const [rowData, setRowData] = useState([]);
  const [show, setshow] = useState(false);
  const [showBrand, setShowBrand] = useState(false);
  const [arrangeBrand, setArrangeBrand] = useState([]);
  const [dPlan, setdPlan] = useState(false);
  const [dExpireDate, setdExpireDate] = useState(false);
  const [showOnce, setShowOnce] = useState(true);
  const [bundle, setBundle] = useState([]);
  const [selectBundle, setSelectBundle] = useState([]);
  const [showBundle, setShowBundle] = useState(false);

  const downloadProductCsv = async () => {
    console.log('finalProd', finalProd);
    let newArray = [];
    finalProd.forEach((element) => {
      const newObj = {};
      newObj.name = element.id.name;
      newObj.upc = element.id.upc;
      newObj.price = element.id.price;
      newObj.modified_price = element.nPrice ? element.nPrice : '';
      newObj.category = element.category;
      newObj.best_seller = element.bestSeller;
      newArray.push(newObj);
    });

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Machine_Products',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      filename: 'Machine_Products',
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(newArray);
  };

  useEffect(() => {
    console.log('filterd', filterd);
    // Check if filterd array exists and has elements
    if (!filterd || filterd.length === 0) {
      console.error('No machines selected, redirecting to view all machines');
      history.push('/dashboard/viewmymachines');
      return;
    }

    const filterdID = filterd.map((e) => e._id);
    const getMachine = async () => {
      await request({
        method: 'post',
        url: getMachineURL,
        data: {
          machineID: filterdID,
        },
      }).then((res) => {
        let myP = [...res.data[0]];
        let mapBundle = res.data[5]?.map((e) => {
          return {
            id: e,
          };
        });

        //merge products and bundles
        myP = [...myP, ...mapBundle];
        myP?.forEach((e) => {
          e.id.name = e.id.name.en;
        });
        let finalProd = [];

        myP.forEach((prod) => {
          //setcategory
          let category = '';
          prod.id?.category.forEach((element, i) => {
            category += element.name?.en;
            if (i < prod.id?.category?.length - 1) {
              category += ', ';
            }
          });
          prod.category = category;

          const index = res.data[1]?.findIndex((e) => e.id === prod.id?._id);
          const index2 = res.data[2]?.findIndex((e) => e.id === prod.id?._id);
          const index3 = res.data[3]?.findIndex((e) => e === prod.id?._id);
          const index4 = res.data[4]?.findIndex((e) => e === prod.id?._id);

          // combind price
          if (index > -1) {
            prod.nPrice = res.data[1][index].price;
          }

          if (index2 > -1) {
            prod.plans = res.data[2][index2].plan;
          } else {
            prod.plans = null;
          }

          if (index3 > -1) {
            prod.bestSeller = true;
          } else {
            prod.bestSeller = false;
          }

          //hide product
          if (index4 > -1) {
            prod.hide = true;
          } else {
            prod.hide = false;
          }

          // set products_expire_date - filter all entries for this product
          prod.products_expire_date = res.data[6]?.filter((e) => e.id === prod.id?._id) || [];

          //change
          if (finalProd.length === 0) {
            finalProd.push({
              id: prod.id,
              plans: prod.plans,
              nPrice: prod.nPrice,
              bestSeller: prod.bestSeller,
              category: prod.category,
              hide: prod.hide,
              products_expire_date: prod.products_expire_date,
            });
          } else {
            if (prod.id) {
              const index = finalProd.findIndex((x) => x.id?._id === prod.id?._id);
              if (index === -1) {
                const addP = {
                  id: prod.id,
                  plans: prod.plans,
                  nPrice: prod.nPrice,
                  bestSeller: prod.bestSeller,
                  category: prod.category,
                  hide: prod.hide,
                  products_expire_date: prod.products_expire_date,
                };
                finalProd.push(addP);
              }
            }
          }
        });

        finalProd.sort(function (a, b) {
          if (a.bestSeller > b.bestSeller) {
            return -1;
          }
          if (a.bestSeller < b.bestSeller) {
            return 1;
          }
          return res.data[3].indexOf(a.id._id) - res.data[3].indexOf(b.id._id);
        });

        console.log('finalProd', finalProd);
        setFinalProd(finalProd);
        setLoading(true);
      });
    };
    getMachine();

    const getProductBundle = async () => {
      await request({
        method: 'get',
        url: `/products/${id}/bundle`,
      })
        .then((res) => {
          setBundle(res.data);
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to get bundle',
          });
        });
    };
    getProductBundle();

    let string = '';
    filterd.forEach((e) => {
      string += e.name + ', ';
    });
    string = string.substring(0, string.length - 2);
    setTitle(string);

    return () => {
      setFinalProd([]);
    };
  }, [reflesh]);

  const updateProduct = async (data) => {
    console.log('finalProd', finalProd);
    const prodPrice = [];
    const prodPlan = [];
    const prodBs = [];
    const prodHide = [];
    const productsExpireDate = [];
    let bsCount = 0;
    let hideCount = 0;
    data.forEach((prod) => {
      if (prod.nPrice) {
        prodPrice.push({ id: prod.id._id, price: prod.nPrice ? prod.nPrice : prod.id.price });
      }
      if (prod.bestSeller) {
        prodBs.push(prod.id._id);
        bsCount++;
      }

      if (prod.plans) {
        prodPlan.push({
          id: prod.id._id,
          plan: prod.plans,
        });
      }
      if (prod.hide) {
        prodHide.push(prod.id._id);
        hideCount++;
      }
      // Add products_expire_date array if it exists
      if (prod.products_expire_date && prod.products_expire_date.length > 0) {
        prod.products_expire_date.forEach((expireEntry) => {
          productsExpireDate.push(expireEntry);
        });
      }
    });
    console.log(prodHide, 'prodHide');

    await request({
      method: 'post',
      url: addProdToMachineURL,
      data: {
        machineID: machineID ? new Array(machineID) : filterd.map((e) => e._id),
        product: prodPrice.length > 0 ? prodPrice : null,
        plan: prodPlan.length > 0 || dPlan ? prodPlan : null,
        bs: prodBs.length > 0 || bsCount === 0 ? prodBs : null,
        hide: prodHide.length > 0 || hideCount === 0 ? prodHide : null,
        products_expire_date:
          productsExpireDate.length > 0 || dExpireDate ? productsExpireDate : null,
      },
    }).then((res) => {
      Swal.fire({
        text: `The product has been successfully updated`,
        icon: 'success',
        target: document.getElementById('swal2-container'),
      }).then((e) => {
        reflesh ? setReflesh(false) : setReflesh(true);
      });
    });
  };

  const updateProd = async (id) => {
    let newArray = Object.values(id);
    newArray = newArray.map((e) => e.newData);

    newArray.forEach((changes) => {
      finalProd.forEach((element) => {
        if (element.id._id === changes.id._id) {
          element.nPrice = changes.nPrice;
          element.bestSeller = changes.bestSeller;
          element.hide = changes.hide;
        }
      });
    });

    setFinalProd([...finalProd]);
  };

  const addPlan = async (data) => {
    setRowData(data);
    setshow(true);
  };

  const handleSubmit = async (data) => {
    const prodsb = [];

    arrangeBrand.forEach((prod) => {
      prodsb.push(prod.id._id);
    });
    await request({
      method: 'post',
      url: addProdToMachineURL,
      data: {
        machineID: machineID ? new Array(machineID) : filterd.map((e) => e._id),
        bs: prodsb,
      },
    }).then((e) => {
      setShowBrand(false);
      Swal.fire('', 'Position saved', 'success').then((e) => {
        reflesh ? setReflesh(false) : setReflesh(true);
      });
    });
  };

  const arrangeProduct = async (data) => {
    let newBrand = [...finalProd];
    newBrand = newBrand.filter((e) => {
      e._id = e.id._id;
      if (e.bestSeller) {
        return e;
      }
    });
    setArrangeBrand(newBrand);
    setShowBrand(true);
  };

  const selectAll = async (data) => {
    data.forEach((changes) => {
      finalProd.forEach((element) => {
        if (element.id._id === changes.id._id) {
          element.bestSeller = true;
        }
      });
    });
    setFinalProd([...finalProd]);

    Swal.fire({
      text: `Please disable edit mode(if you are in edit mode) to see the changes`,
      icon: 'warning',
    });
  };

  const unSelectAll = async (data) => {
    data.forEach((changes) => {
      finalProd.forEach((element) => {
        if (element.id._id === changes.id._id) {
          element.bestSeller = false;
        }
      });
    });
    setFinalProd([...finalProd]);

    Swal.fire({
      text: `Please disable edit mode(if you are in edit mode) to see the changes`,
      icon: 'warning',
    });
  };

  const deletePlan = async (data) => {
    const index2 = finalProd.findIndex((e) => e.id?._id === data?.id._id);
    if (index2 > -1) {
      finalProd[index2].plans = null;
      console.log('22222');
    }
    console.log(finalProd);
    setFinalProd([...finalProd]);
    setdPlan(true);
  };

  const setExpireDate = async (data) => {
    // Get all positions for this product from filterd[0].product
    const machineProducts = filterd[0]?.product || [];
    const productPositions = machineProducts
      .filter((p) => p.id === data.id._id)
      .map((p) => {
        // Extract floor and lane from pos string (e.g., "4F 2L 2W undefinedS")
        const posParts = p.pos.split(' ');
        const floor = posParts[0] || '';
        const lane = posParts[1] || '';
        return {
          pos: p.pos,
          display: `Floor ${floor} - Lane ${lane}`,
          _id: p._id,
        };
      });

    // Format current expire_date for date input if it exists
    let currentValue = '';
    // Get the first expire date if any exists
    if (data.products_expire_date && data.products_expire_date.length > 0) {
      const firstDate = data.products_expire_date[0].expire_date;
      currentValue = firstDate;
    }

    // Build position options HTML
    const positionOptions = `
      <option value="all">All Positions</option>
      ${productPositions.map((p) => `<option value="${p.pos}">${p.display}</option>`).join('')}
    `;

    // Build current expire dates display for each position
    const expireDatesDisplay = productPositions
      .map((p) => {
        // Find expire date for this position from products_expire_date array
        let expireDate = 'Not set';
        if (data.products_expire_date && data.products_expire_date.length > 0) {
          const expireEntry = data.products_expire_date.find(
            (e) => e.position === p.pos || (e.position === 'all' && expireDate === 'Not set')
          );
          if (expireEntry) {
            expireDate = expireEntry.expire_date;
          }
        }
        return `
          <div style="display: flex; justify-content: space-between; padding: 8px; border-bottom: 1px solid #eee;">
            <span style="font-weight: 500;">${p.display}</span>
            <span style="color: ${
              expireDate === 'Not set' ? '#999' : '#ff9800'
            };">${expireDate}</span>
          </div>
        `;
      })
      .join('');

    Swal.fire({
      title: 'Manage Expire Date',
      html: `
        <div style="text-align: left; margin-bottom: 15px;">
          <strong>Product:</strong> ${data.id.name}
        </div>
        <div style="text-align: left; margin-bottom: 20px;">
          <strong>UPC:</strong> ${data.id.upc}
        </div>
        <div style="text-align: left; margin-bottom: 20px;">
          <strong>Current Expire Dates by Position:</strong>
          <div style="margin-top: 10px; border: 1px solid #ddd; border-radius: 4px; max-height: 200px; overflow-y: auto;">
            ${expireDatesDisplay}
          </div>
        </div>
        <div style="text-align: left; margin-bottom: 20px;">
          <label for="position-select" style="display: block; margin-bottom: 8px; font-weight: 600;"><strong>Select Position:</strong></label>
          <select id="position-select" class="swal2-input" style="width: 100%; margin: 0; padding: 10px;">
            ${positionOptions}
          </select>
        </div>
        <div style="text-align: left; margin-bottom: 10px;">
          <label for="expire-date-input" style="display: block; margin-bottom: 8px; font-weight: 600;"><strong>Select Date:</strong></label>
          <input type="date" id="expire-date-input" class="swal2-input" value="${currentValue}" style="width: 100%; margin: 0; padding: 10px;">
        </div>
      `,
      showDenyButton:
        data.products_expire_date && data.products_expire_date.length > 0 ? true : false,
      showCancelButton: true,
      confirmButtonText: 'Set Date',
      denyButtonText: 'Clear Date',
      cancelButtonText: 'Cancel',
      preConfirm: () => {
        const dateValue = document.getElementById('expire-date-input').value;
        const positionValue = document.getElementById('position-select').value;
        if (!dateValue) {
          Swal.showValidationMessage('Please select a date');
          return false;
        }
        return { date: dateValue, position: positionValue };
      },
      preDeny: () => {
        const positionValue = document.getElementById('position-select').value;
        return { position: positionValue };
      },
    }).then((result) => {
      const index = finalProd.findIndex((e) => e.id?._id === data.id._id);
      if (index === -1) return;

      if (result.isConfirmed) {
        if (!finalProd[index].products_expire_date) {
          finalProd[index].products_expire_date = [];
        }

        if (result.value.position === 'all') {
          // If "All Positions" is selected, set the same date for all positions of this product
          // First remove all existing entries for this product
          finalProd[index].products_expire_date = finalProd[index].products_expire_date.filter(
            (e) => e.id !== data.id._id
          );

          // Then add an entry for each position
          productPositions.forEach((pos) => {
            finalProd[index].products_expire_date.push({
              id: data.id._id,
              expire_date: result.value.date,
              position: pos.pos,
              upc: data.id.upc,
            });
          });
        } else {
          // If specific position is selected, remove old entry for this position and add new one
          finalProd[index].products_expire_date = finalProd[index].products_expire_date.filter(
            (e) => e.position !== result.value.position
          );
          finalProd[index].products_expire_date.push({
            id: data.id._id,
            expire_date: result.value.date,
            position: result.value.position,
            upc: data.id.upc,
          });
        }

        setFinalProd([...finalProd]);
        Swal.fire({
          text: `Expire date set. Please click 'Save Changes' to save.`,
          icon: 'success',
        });
      } else if (result.isDenied) {
        // Clear date based on selected position
        if (!finalProd[index].products_expire_date) {
          finalProd[index].products_expire_date = [];
        }

        if (result.value.position === 'all') {
          // Clear all positions for this product
          finalProd[index].products_expire_date = finalProd[index].products_expire_date.filter(
            (e) => e.id !== data.id._id
          );
        } else {
          // Clear specific position
          finalProd[index].products_expire_date = finalProd[index].products_expire_date.filter(
            (e) => e.position !== result.value.position
          );
        }

        setFinalProd([...finalProd]);
        setdExpireDate(true);

        // Show success message then reopen the modal
        Swal.fire({
          text: `Expire date cleared. Please click 'Save Changes' to save.`,
          icon: 'info',
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          // Reopen the modal with updated data
          setExpireDate(finalProd[index]);
        });
      }
    });
  };

  const columns = [
    {
      title: 'Best Seller',
      field: 'bestSeller',
      type: 'boolean',
    },
    {
      title: 'Disable',
      field: 'hide',
      type: 'boolean',
    },
    {
      title: 'Picture',
      field: 'id.productPicture',
      editable: 'never',
      render: (rowData) => (
        <img
          src={`${process.env.REACT_APP_SERVER_API}/pictures/${rowData.id.productPictures[0]}/${id}`}
          style={{
            maxWidth: 200,
            maxHeight: 75,
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[2],
          }}
          alt={rowData.id.name}
        />
      ),
    },
    {
      title: 'Product Name',
      editable: 'never',
      field: 'id.name',
      cellStyle: {
        textAlign: 'left',
      },
      headerStyle: {
        textAlign: 'left',
      },
      render: (rowData) => (
        <Typography variant="body1" sx={{ fontWeight: 600 }}>
          {rowData.id.name}
        </Typography>
      ),
    },
    {
      title: 'UPC/SKU',
      editable: 'never',
      field: 'id.upc',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
          {rowData.id.upc}
        </Typography>
      ),
    },
    {
      title: 'Category',
      field: 'category',
      editable: 'never',
      render: (rowData) =>
        rowData.category ? (
          <Chip
            icon={<CategoryIcon sx={{ fontSize: 16 }} />}
            label={rowData.category}
            size="small"
            sx={{
              fontWeight: 600,
              backgroundColor: alpha(theme.palette.info.main, 0.12),
              color: theme.palette.info.dark,
              border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
              '& .MuiChip-icon': {
                color: theme.palette.info.dark,
              },
            }}
          />
        ) : null,
    },
    {
      title: 'Plan',
      editable: 'never',
      field: 'plans',
      render: (rowData) =>
        rowData.plans &&
        rowData.plans.plan.map((e, i) => {
          return (
            <Typography key={i} variant="body2">
              {e.name}
            </Typography>
          );
        }),
    },

    {
      title: 'Price',
      field: 'nPrice',
      type: 'numeric',
      render: (rowData) => (
        <Chip
          icon={<AttachMoneyIcon sx={{ fontSize: 16 }} />}
          label={rowData.nPrice ? `$${rowData.nPrice}` : `$${rowData.id.price}`}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.success.dark,
            },
          }}
        />
      ),
      editable: additionPriceOn ? 'never' : 'always',
    },
    // {
    //   title: 'Expire Date',
    //   field: 'products_expire_date',
    //   editable: 'never',
    //   render: (rowData) => {
    //     const expireDates = rowData.products_expire_date || [];
    //     if (expireDates.length === 0) {
    //       return (
    //         <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
    //           No expiry
    //         </Typography>
    //       );
    //     }

    //     // Group by date to show unique dates
    //     const uniqueDates = [...new Set(expireDates.map(e => e.expire_date))];

    //     return (
    //       <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
    //         {uniqueDates.map((date, i) => (
    //           <Chip
    //             key={i}
    //             icon={<EventIcon sx={{ fontSize: 16 }} />}
    //             label={date}
    //             size="small"
    //             sx={{
    //               fontWeight: 600,
    //               backgroundColor: alpha(theme.palette.warning.main, 0.12),
    //               color: theme.palette.warning.dark,
    //               border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
    //               '& .MuiChip-icon': {
    //                 color: theme.palette.warning.dark,
    //               },
    //             }}
    //           />
    //         ))}
    //       </Box>
    //     );
    //   },
    // },
  ];

  return (
    <ModernPageContainer>
      <ModernPageHeader
        title="Update Products"
        subtitle={`For Machines: ${title}`}
        icon={Inventory2Icon}
        buttons={[
          access && {
            text: 'Save Changes',
            icon: SaveIcon,
            onClick: () => updateProduct(finalProd),
            variant: 'contained',
          },
          {
            text: 'Go Back',
            icon: ArrowBackIcon,
            onClick: () => history.goBack(),
            variant: 'outlined',
          },
        ].filter(Boolean)}
      />

      {!loading ? (
        <LoadingIcon />
      ) : (
        <Box sx={{ width: '100%' }}>
          <ModernTable
            tableRef={tableRef}
            columns={columns}
            data={finalProd}
            title=""
            editable={
              access && {
                onBulkUpdate: (changes) =>
                  new Promise((resolve) => {
                    setTimeout(() => {
                      Swal.fire({
                        text: `Please click 'Save Changes' button in the header to actually save the changes`,
                        icon: 'info',
                      });
                      updateProd(changes);
                      resolve();
                    }, 1000);
                  }),
              }
            }
            // actions={[
            //   access &&
            //     filterd.length === 1 && {
            //       tooltip: 'Manage Expire Date & Time',
            //       icon: EventIcon,
            //       onClick: (_evt, data) => {
            //         setExpireDate(data);
            //       },
            //     },
            //   access && {
            //     tooltip: 'Select All Best Seller',
            //     isFreeAction: true,
            //     icon: CheckBoxIcon,
            //     onClick: (_evt, _data) => {
            //       selectAll(tableRef.current.dataManager?.searchedData);
            //     },
            //   },
            //   access && {
            //     tooltip: 'Unselect All Best Seller',
            //     isFreeAction: true,
            //     icon: CancelIcon,
            //     onClick: (_evt, _data) => {
            //       unSelectAll(tableRef.current.dataManager?.searchedData);
            //     },
            //   },
            //   !additionPriceOn && {
            //     icon: RestartAltIcon,
            //     tooltip: 'Reset Price',
            //     isFreeAction: true,
            //     onClick: (_event) => {
            //       Swal.fire({
            //         title: 'Are you sure to reset all price?',
            //         text: "You won't be able to revert this!",
            //         icon: 'warning',
            //         showCancelButton: true,
            //         confirmButtonColor: '#3085d6',
            //         cancelButtonColor: '#d33',
            //         confirmButtonText: 'Yes, reset it!',
            //       }).then(async (result) => {
            //         if (result.isConfirmed) {
            //           await request({
            //             method: 'post',
            //             url: addProdToMachineURL,
            //             data: {
            //               machineID: machineID ? new Array(machineID) : filterd.map((e) => e._id),
            //               product: [],
            //             },
            //           }).then((_e) => {
            //             Swal.fire(
            //               'Price reset!',
            //               'All products is reset to default price.',
            //               'success'
            //             ).then((_e) => {
            //               reflesh ? setReflesh(false) : setReflesh(true);
            //             });
            //           });
            //         }
            //       });
            //     },
            //   },
            //   access && {
            //     tooltip: 'Arrange Products',
            //     isFreeAction: true,
            //     icon: LowPriorityIcon,
            //     onClick: (_evt, _data) => {
            //       arrangeProduct(finalProd);
            //     },
            //   },
            //   {
            //     isFreeAction: true,
            //     tooltip: 'Download CSV',
            //     icon: CloudDownload,
            //     onClick: (_evt, _data) => {
            //       downloadProductCsv(finalProd);
            //     },
            //   },
            //   bundle.length > 0 && {
            //     isFreeAction: true,
            //     tooltip: 'Add Bundle To Machine',
            //     icon: AddIcon,
            //     onClick: (_evt, _data) => {
            //       setShowBundle(true);
            //     },
            //   },
            // ].filter(Boolean)}
            options={{
              actionsColumnIndex: -1,
              selection: false,
              pageSize: 10,
              pageSizeOptions: [5, 10, 20, 50, 100],
              headerStyle: {
                textAlign: 'left',
              },
              cellStyle: {
                textAlign: 'left',
              },
              idSynonym: 'id._id',
            }}
          />
        </Box>
      )}
      <AddPlan
        show={show}
        reflesh={+reflesh}
        setReflesh={setReflesh}
        data={rowData}
        finalProd={finalProd}
        id={id}
        onHide={() => setshow(false)}
      />
      <ProductPositionModal
        show={showBrand}
        brand={arrangeBrand}
        setBrand={setArrangeBrand}
        onHide={() => setShowBrand(false)}
        handleSubmit={handleSubmit}
        referTo={filterd?.[0]?.belongTo}
      />
      <AddBundleToMachine
        id={id}
        setFiltered={setFiltered}
        reflesh={reflesh}
        setReflesh={setReflesh}
        filterd={filterd}
        show={showBundle}
        bundle={bundle}
        selectBundle={selectBundle}
        setSelectBundle={setSelectBundle}
        onHide={() => setShowBundle(false)}
        referTo={filterd?.[0]?.belongTo}
      />
    </ModernPageContainer>
  );
}
